export default __webpack_public_path__ + "static/media/17.58d417fe.jpg";